import { get } from 'svelte/store';

import { api } from '../../../stores/api';
import { NotificationSystemApi } from './NotificationSystemApi';
// import { NotificationSystemQueries } from './NotificationSystemQueries';
import { NotificationSystemContext } from './NotificationSystemContext';

export class NotificationSystemApp {
    context: NotificationSystemContext = new NotificationSystemContext();
    // msq: NotificationSystemQueries = new NotificationSystemQueries();
    checkDataTimeIntervalSeconds = 30;
    intervalHandler: any;
    api: any = get(api);
    onCheckData: (context: NotificationSystemContext) => void;

    constructor() {
        this.onCheckData = () => {};
    }

    start(onCheckData: (context: NotificationSystemContext) => void) {
        this.onCheckData = onCheckData;
        this.checkData();
        this.stop();
        console.log('start, intervalHandler 1', this.intervalHandler);
        this.intervalHandler = setTimeout(() => {
            this.checkData();
        }, this.checkDataTimeIntervalSeconds * 1000);
    }

    changeIntervalSeconds(seconds: number) {
        this.checkDataTimeIntervalSeconds = seconds;
        this.stop();
        console.log('start, intervalHandler 2', this.intervalHandler);
        this.intervalHandler = setTimeout(() => {
            this.checkData();
        }, this.checkDataTimeIntervalSeconds * 1000);
    }

    reload() {
        this.checkData();
    }

    stop() {
        if (this.intervalHandler) {
            console.log('start, stop', this.intervalHandler);
            clearTimeout(this.intervalHandler);
            this.intervalHandler = null;
        }
    }

    async getJobsData() {
        const data = await Promise.all([
            NotificationSystemApi.countRoutesToCalculate(this.api),
            NotificationSystemApi.countRoutesInCalculation(this.api),
        ]);
        this.context = {
            ...this.context,
            countRoutesToCalculate: data[0].count,
            countRoutesInCalculation: data[1].count,
        };
        return this.context;
    }

    async calcRoutesNeededToCalculate() {
        return NotificationSystemApi.calcRoutesNeededToCalculate(this.api);
    }

    checkData() {
        this.stop();
        Promise.all([
            NotificationSystemApi.getRouteCalcStatus(this.api),
            NotificationSystemApi.countNotGeocodedLocations(this.api),
        ])
            .then(data => {
                this.context = {
                    ...this.context,
                    countRoutesToCalculate: data[0].to_calculate,
                    countRoutesInCalculation: data[0].in_calculation,
                    pendingCalculationsCounters: data[0].pending,
                    countNotGeocodedLocations: data[1].count,
                };

                this.onCheckData(this.context);
                this.stop();
                console.log('start, intervalHandler 3', this.intervalHandler);
                this.intervalHandler = setTimeout(() => {
                    this.checkData();
                }, this.checkDataTimeIntervalSeconds * 1000);
            })
            .catch(e => {
                console.error(e);
                this.stop();
                console.log('start, intervalHandler 4', this.intervalHandler);
                this.intervalHandler = setTimeout(
                    () => {
                        this.checkData();
                    },
                    this.checkDataTimeIntervalSeconds * 1000 * 5
                );
            });
    }

    reloadInterval(seconds: number) {
        this.stop();
        this.changeIntervalSeconds(seconds);
        this.start(this.onCheckData);
    }
}
